module.exports = __webpack_public_path__ + "static/media/ic-3.8e7096ee.svg";